// extracted by mini-css-extract-plugin
module.exports = {"root":"DateRangeFilter_root__1cie_","form":"DateRangeFilter_form__1W_vD","periods":"DateRangeFilter_periods__2sfFw"};